module.exports = __webpack_public_path__ + "static/media/ped-logo.611324ce.png";